<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      大运站<br>
站点介绍<br>
大运站位于深圳市龙岗区机荷高速路和黄阁南路之间,机荷高速北侧的龙岗大道下方与龙飞大道交叉路口西南侧，沿龙岗大道转入爱南路北向布置。大运站是14号线与3号线、16号线的换乘站，车站色彩基调以白色调为主突显科技感，结合蓝色展现科技与未来。大运站为地下三层双岛式站台车站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	23:12	3号线	2分15-20秒	4分30秒<br>
双龙	06:12	00:00	3号线	2分15-20秒	4分30秒<br>
岗厦北	06:29	23:27	14号线	4分30秒	6分15秒<br>
沙田	06:27	23:57	14号线	4分30秒	6分15秒<br>
大运	06:00	23:00	16号线	5分32秒	6分32秒<br>
田心	--	--	16号线	5分32秒	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	23:11	3号线	3分15秒	5分钟<br>
双龙	06:15	00:00	3号线	3分15秒	5分钟<br>
岗厦北	06:27	23:27	14号线	5分25秒	6分15秒<br>
沙田	06:27	23:57	14号线	5分25秒	6分15秒<br>
大运	06:00	23:00	16号线	5分50秒	6分钟-9分钟<br>
田心	--		16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	00:11	3号线	3分15秒	5分钟<br>
双龙	06:15	01:00	3号线	3分15秒	5分钟<br>
岗厦北	06:27	00:27	14号线	5分钟	6分15秒<br>
沙田	06:27	00:57	14号线	5分钟	6分15秒<br>
大运	06:00	00:00	16号线	5分50秒	6分钟-9分钟<br>
田心	--	--	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
1/2号出入口:<br>
大运软件小镇<br><br>
3号出入口:<br>
龙飞大道南侧、龙岗大道西侧<br><br>
4/5/6号出入口:<br>
龙岗大道西侧、桂坪路口<br><br>
7号出入口:<br>
龙岗大道西侧<br><br>
8/9/10号出入口:<br>
大运软件小镇、龙岗大道东侧.11号出入口<br><br>
公交换乘信息<br><br>
2号出入口:<br>
公交站名： 大运地铁站①<br>
351、M322、M266、M314、E34、M239、358、M396、833、M294、E33、M22、M466、E23、923<br><br>
10B出入口:<br>
公交站名： 大运地铁站②<br>
M359、M360、M547、M546、M368<br><br>
10A出入口:<br>
公交站名： 大运地铁站③<br>
M219、,357、M303<br><br>
14号出入口:<br>
公交站名： 大运地铁站<br>
E33、M357、M547、923、M360、M359、358、M229、351、M396、M266、M239、833、M466、M314、E23、M368<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "sanhaoxian",
            title: "3号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },

        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>